import { Button, FormControlLabel, IconButton, InputAdornment, TextField, Typography } from '@mui/material';
import apiManagerUser from 'api/manager-users';
import { LockIcon, VisibleIcon, VisibleOffIcon } from 'components/common/IconCommon';
import { useDialog } from 'components/DialogV3';
import DialogAcceptPolicy from 'components/DialogV3/DialogAcceptPolicy';
import { PATH_ROOT } from 'constants/api';
import { AccountAlreadyExists } from 'layouts';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { establishSession } from 'store/sessionSlice';
import { toastError, toastSuccess } from 'utils/helpers';
import InfoUserSSO from './InfoUserSSO';
import { TOAST_DEFAULT } from 'constants/toast';
import { useAuthFlow } from '../AuthFlowContext';

export default function RegisterSSOSameEmail(props) {
    const { handleSubmit, register, formState: { errors, isValid }, watch } = useForm({ mode: 'onChange' });
    const { email, username, isProvideService } = props.SSOInfo
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { sso, clearSSOFlow } = useAuthFlow();
    const SSOAccessToken = sso.accessToken;
    const [showPass, setShowPass] = useState(false);
    const handleClickShowPass = () => setShowPass(!showPass);
    const provider = props.provider
    const { openDialog } = useDialog()
    const [needAcceptShareInfo, setNeedAcceptShareInfo] = useState(false);

    const textFiledType = showPass ? 'text' : 'password'

    const _handleSubmit = async (data) => {
        try {
            const res = await apiManagerUser.registerSSOLinkAccount({ access_token: SSOAccessToken, password: data.userp, ...props.SSOInfo }, provider, undefined, undefined);

            toastSuccess(t('toast.loginSuccess'));
            const { accessToken, refreshToken } = res?.data
            dispatch(establishSession({ accessToken, refreshToken }));
            clearSSOFlow();
            navigate(`${PATH_ROOT}/profile-user${isProvideService ? '?provide-service=true' : ''}`)
        } catch (error) {
            if (error?.response?.data?.data?.message === 'WRONG_PASSWORD') {
                toastError(t('toast.wrongPassword'))
            } else if (error?.response?.data?.message === 'not-verify') {
                toastError(t('toast.notVerify'))
            } else if (error?.response?.data?.data?.message === 'PI_SHARE_NOT_ALLOW') {
                setNeedAcceptShareInfo(true);
            } else {
                toastError(t(TOAST_DEFAULT.ERROR))
            }
        }
    }

    useEffect(() => {
        if (!email) {
            navigate(`${PATH_ROOT}/auth/register`)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (needAcceptShareInfo) {
            openDialog(DialogAcceptPolicy, {
                onAction: async (policies) => {
                    try {
                        const res = await apiManagerUser.registerSSOLinkAccount({ access_token: SSOAccessToken, password: watch('userp'), ...props.SSOInfo }, provider, undefined, policies)
                        
                        toastSuccess(t('toast.loginSuccess'));
                        const { accessToken, refreshToken } = res?.data
                        dispatch(establishSession({ accessToken, refreshToken }));
                        clearSSOFlow();
                        navigate(`${PATH_ROOT}/profile-user${isProvideService ? '?provide-service=true' : ''}`)
                    } catch (error) {
                        if (error?.response?.data?.data?.message === 'WRONG_PASSWORD') {
                            toastError(t('toast.wrongPassword'))
                        } else if (error?.response?.data?.message === 'not-verify') {
                            toastError(t('toast.notVerify'))
                        } else if (error?.response?.data?.data?.message === 'PI_SHARE_NOT_ALLOW') {
                            setNeedAcceptShareInfo(true);
                        } else {
                            toastError(t(TOAST_DEFAULT.ERROR))
                        }
                    }
                },
                onReject: () => { toastError(t('toast.error.title.registerError'), t('toast.error.content.sharingInfo'), { autoClose: 5000 }); navigate(`${PATH_ROOT}/login`) }
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [needAcceptShareInfo])

    return (
        <>
            <Typography fontSize={28} fontWeight={600} textAlign={'center'} mb={1.5}>{t('dialog.regiter-sso-same-sso.title')}</Typography>
            <div className="body-create-account">
                <Typography mb={3}>
                    {t('dialog.regiter-sso-same-sso.intro', { provider: t(`auth.${provider}`) })}
                </Typography>
                <InfoUserSSO username={username} SSOInfo={props.SSOInfo} />
                <form onSubmit={_handleSubmit(handleSubmit)}>
                    <FormControlLabel labelPlacement='top' label={t('dialog.regiter-sso-same-sso.title-account')} required control={
                        <TextField {...register('userp', {
                            required: 'validate.pwdRequired'
                        })} autoFocus type={textFiledType} error={errors?.userp} 
                        helperText={errors?.userp?.message} placeholder={t('placeholder.password')}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <LockIcon sx={{ color: '#949595', position: 'relative' }} />
                                        <IconButton
                                            style={{ marginRight: '10px', position: 'absolute', right: 0 }}
                                            tabIndex={-1}
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPass}
                                        >
                                            {showPass ? <VisibleIcon /> : <VisibleOffIcon />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }} />
                    } />

                    <Button
                        disabled={!isValid}
                        size="large"
                        type={'submit'}
                        variant="contained"
                        fullWidth
                    >
                        {t('dialog.regiter-sso-same-sso.link')}
                    </Button>
                </form>
                <AccountAlreadyExists />
            </div>
        </>
    );
}
